/**
 * Starter templates for new config creation.
 *
 * Templates are written in the storage/API format — the same shape that
 * `configToForm()` expects when loading a config version from the backend.
 * This keeps a single conversion path: template → configToForm → wizard state.
 *
 * Users replace the placeholder CSS selectors with their real ones.
 */

export const TEMPLATES = [
  {
    id: 'approval',
    name: 'Approval Workflow',
    description: 'Submit → Review → Approve',
    icon: '📝',
    config: {
      processes: [{
        process_id: 'approval-workflow',
        process_name: 'Approval Workflow',
        enabled: true,
        steps: [
          {
            step_id: 'submitted',
            label: 'Submitted',
            application_name: 'Your App',
            url_pattern: 'https://your-app.com/submit/*',
            enabled: true,
            trigger: { type: 'click', selector: '#submit-btn' },
            identifiers: {
              request_id: { selector: '#request-id', attribute: 'innerText', required: true }
            },
            custom_fields: {}
          },
          {
            step_id: 'reviewed',
            label: 'Reviewed',
            application_name: 'Your App',
            url_pattern: 'https://your-app.com/review/*',
            enabled: true,
            trigger: { type: 'click', selector: '#review-complete-btn' },
            identifiers: {
              request_id: { selector: '#request-id', attribute: 'innerText', required: true }
            },
            custom_fields: {}
          },
          {
            step_id: 'approved',
            label: 'Approved',
            application_name: 'Your App',
            url_pattern: 'https://your-app.com/review/*',
            enabled: true,
            trigger: { type: 'click', selector: '#approve-btn' },
            identifiers: {
              request_id: { selector: '#request-id', attribute: 'innerText', required: true }
            },
            custom_fields: {}
          }
        ]
      }]
    }
  },
  {
    id: 'order-flow',
    name: 'Order Flow',
    description: 'Cart → Checkout → Confirm',
    icon: '🛒',
    config: {
      processes: [{
        process_id: 'order-flow',
        process_name: 'Order Flow',
        enabled: true,
        steps: [
          {
            step_id: 'add-to-cart',
            label: 'Added to Cart',
            application_name: 'Your Store',
            url_pattern: 'https://your-store.com/products/*',
            enabled: true,
            trigger: { type: 'click', selector: '.add-to-cart-btn' },
            identifiers: {
              order_id: { selector: '#order-id', attribute: 'innerText', required: true }
            },
            custom_fields: {}
          },
          {
            step_id: 'checkout',
            label: 'Checkout Started',
            application_name: 'Your Store',
            url_pattern: 'https://your-store.com/checkout/*',
            enabled: true,
            trigger: { type: 'click', selector: '#proceed-checkout' },
            identifiers: {
              order_id: { selector: '#order-id', attribute: 'innerText', required: true }
            },
            custom_fields: {}
          },
          {
            step_id: 'confirmed',
            label: 'Order Confirmed',
            application_name: 'Your Store',
            url_pattern: 'https://your-store.com/confirmation/*',
            enabled: true,
            trigger: { type: 'click', selector: '#confirm-order' },
            identifiers: {
              order_id: { selector: '.order-number', attribute: 'innerText', required: true }
            },
            custom_fields: {}
          }
        ]
      }]
    }
  }
];
